import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Button } from "@progress/kendo-react-buttons";
import { Localization } from "../../common/Localization";
import DialogWindow from "../../common/DialogWindow.js";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum } from "../../../enums/index.js";
import confirmService from "../../common/confirmService/index.js";
import { toolsController } from "../../../controllers/tools.controller";
import ExpediciaNegenerovaneSpravy from "./ExpediciaNegenerovaneSpravy";
import { dateConvert } from "../../common/Helpers";

class ExpediciaNegenerovaneSpravyDialogContent extends Component {
    state = {
        items: [],
        selectedItemIds: [],
        disableButtons: false,
        loading: true
    };

    componentDidMount() {
        this.reloadGrid();
    }

    reloadGrid() {
        this.setState({ loading: true });

        toolsController.getExpediciaNegenerovaneSpravy().then(async (response) => {
            let data = JSON.parse(JSON.stringify(response), dateConvert);

            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            } else {
                this.setState({
                    items: data.items
                });
            }

            this.setState({
                selectedItemIds: [],
                disableButtons: false,
                loading: false
            });
        });
    }

    changeSelectedItemIds = (selectedItemIds) => {
        this.setState({
            selectedItemIds: selectedItemIds
        });
    };

    handleVygenerovatSpravu = async () => {
        var localizationService = provideLocalizationService(this);

        if (this.state.selectedItemIds.length === 0) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString(
                    "NahFRM.Vyberte zo zoznamu správy pre vygenerovanie !",
                    "Vyberte zo zoznamu správy pre vygenerovanie !"
                )
            });
            return;
        }

        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.QUESTION,
            message: localizationService.toLanguageString(
                "NahFRM.Naozaj chcete vygenerovať správy pre vybrané záznamy ?",
                "Naozaj chcete vygenerovať správy pre vybrané záznamy ?"
            ),
            buttons: ButtonGroupEnum.OK_CANCEL
        });

        if (confirmResult == ButtonMessageEnum.OK) {
            this.setState({ disableButtons: true });

            toolsController.generovatExpediciaSpravy(this.state.selectedItemIds).then(async (response) => {
                if (response.isError) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: response.errorMessage,
                        logMessage: true
                    });
                } else {
                    await confirmService.show({
                        type: MessageTypeEnum.INFORMATIVE,
                        message: localizationService
                            .toLanguageString("NahFRM.Vygenerované celkem <P1> správ !", "Vygenerované celkem <P1> správ !")
                            .replace("<P1>", response.pocetSprav || "0")
                    });
                }

                this.reloadGrid();
            });
        }
    };

    renderDialogContent() {
        return (
            <div id="NegenerovaneSpravyDialog">
                <div>
                    <div className="col-lg-12">
                        <ExpediciaNegenerovaneSpravy items={this.state.items} changeSelectedItemIds={this.changeSelectedItemIds} />
                    </div>
                </div>
                <div>
                    <div className="col-sm-12 button-bar">
                        <Button
                            onClick={this.handleVygenerovatSpravu}
                            disabled={!this.state.selectedItemIds.length || this.state.disableButtons}
                            icon="wrench"
                            className="auto-focus">
                            <Localization messageKey={"NahFRM.Vygenerovať správy"} defaultMessage={"Vygenerovať správy"} />
                        </Button>
                    </div>
                </div>
                <DialogWindow dialog={this.state.dialog} />
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default ExpediciaNegenerovaneSpravyDialogContent;

registerForLocalization(ExpediciaNegenerovaneSpravyDialogContent);



// WEBPACK FOOTER //
// ./src/components/views/Tools/ExpediciaNegenerovaneSpravyDialogContent.js